declare global {
  interface Window { dataLayer: any; }
}

window.dataLayer = window.dataLayer || {};

export class GTM {
  private videoObj: object;

  constructor ()  {
    this.videoObj = {
      'click': 'Play Button',
      'type': 'Button',
      'action': 'Video plays'
    }
  }

  /**
   * Tracks the video.
   *
   * @param el The video element.
   */
  public trackVideo(el: HTMLVideoElement) {
    const elTitle: HTMLElement = document.querySelector('.carouselItem.zoomed') as HTMLElement;
    const title: string = elTitle.dataset.storytitle;
    const titleMin: string = title.toLowerCase().replace(/\s/g, '');

    let section: string;

    if (el.closest('.carouselItem')) {
      section = 'Hero Video';
    } else {
      let videoModules = el.closest('#story').querySelectorAll('.videoModule');
      let position = Array.from(videoModules).indexOf(el.closest('.videoModule'));
      section = `Video ${position + 1}`;
    }

    this.videoObj['event'] = titleMin;
    this.videoObj['page'] = title;
    this.videoObj['section'] = section;

    if (window.LOCAL) return;

    window.dataLayer.push(this.videoObj);
  }
}

export const gtm = new GTM();
